import {useCallback} from "react";

import {useMutation} from "@khan/data-gql";
import {Errors, KAError} from "@khan/logging";

import type {khanmigoToolsExportQuestionSetToBlooketVariables} from "../graphql/__graphql-types__/khanmigoToolsExportQuestionSetToBlooket.ts";
import {EXPORT_QUESTION_SET_TO_BLOOKET_MUTATION} from "../graphql/export-blooket-question-set-mutation.ts";

export const useExportQuestionSetToBlooket = (): ((
    variables: khanmigoToolsExportQuestionSetToBlooketVariables,
) => Promise<string | undefined>) => {
    const [mutate] = useMutation(EXPORT_QUESTION_SET_TO_BLOOKET_MUTATION);

    return useCallback(
        (variables: khanmigoToolsExportQuestionSetToBlooketVariables) => {
            return mutate(variables)
                .then((result) => {
                    if (result.status === "error") {
                        throw new KAError(
                            "Failed to export question set to blooket",
                            Errors.Service,
                            {
                                cause: result.error,
                            },
                        );
                    }

                    if (result.status === "success") {
                        const {redirectURL, error} =
                            result.data.exportBlooketQuestionSet;

                        if (error) {
                            throw new KAError(
                                "Failed to export question set to blooket",
                                Errors.Service,
                                {
                                    cause: error.code,
                                },
                            );
                        }

                        if (redirectURL) {
                            return redirectURL;
                        }
                    }
                })
                .catch((error) => {
                    if (error instanceof KAError) {
                        throw error;
                    }

                    throw new KAError(
                        "Failed to update blooket",
                        Errors.Internal,
                    );
                });
        },
        [mutate],
    );
};
